import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Container, Link } from '@printdeal/ui-library';

import { FormattedMessage } from 'react-intl';
import Logo from './Logo';
import AccountNavigation from './account-navigation';
import useSystemPages from '../../../hooks/useSystemPages';
import HeaderContextProvider from './HeaderContextProvider';

type MinimalHeaderProps = {
  isPartOfCheckoutFlow?: boolean;
  handleClickOnBackToCartLink?: (event: React.MouseEvent<HTMLElement>) => void;
};

const MinimalHeader = ({ isPartOfCheckoutFlow, handleClickOnBackToCartLink }: MinimalHeaderProps) => {
  const [cartPage] = useSystemPages('cart');

  return (
    <header className="pd-relative pd-z-30">
      <div className="pd-border-b pd-bg-white pd-py-5">
        <Container className="pd-flex pd-items-center pd-gap-3">
          <div className="pd-items-center pd-justify-start pd-gap-5 md:pd-flex">
            <Logo />
            {isPartOfCheckoutFlow && cartPage.path && (
              <Link
                as={GatsbyLink}
                type="button"
                variant="secondary"
                to={cartPage.page}
                onClick={handleClickOnBackToCartLink}
                iconBefore="chevron-left"
                className="pd-mt-2 pd-text-sm md:pd-mt-0 md:pd-text-md"
              >
                <FormattedMessage
                  id="header.minimalHeader.backToCart"
                  defaultMessage="Back to cart"
                />
              </Link>
            )}
          </div>
          <AccountNavigation className="pd-ml-auto" />
        </Container>
      </div>
    </header>
  );
};

const MinimalHeaderWithProviders = (props: MinimalHeaderProps) => (
  <HeaderContextProvider>
    <MinimalHeader {...props} />
  </HeaderContextProvider>
);

export default MinimalHeaderWithProviders;
